import { useId, useState } from 'react';
import type { FC } from 'react';

import { AlertMessage } from '@/ui-kit';
import type { FormFieldWarning } from '../../typings';

import './FieldWarningAlert.scss';

type FieldWarningAlertProps = {
  warning: FormFieldWarning;
};

/** A non-blocking field notice: title always, body behind a Learn more toggle. */
export const FieldWarningAlert: FC<FieldWarningAlertProps> = ({ warning }) => {
  const [expanded, setExpanded] = useState(false);
  const descriptionId = useId();

  return (
    <AlertMessage
      className="alert-message-full-width fwa"
      variant="warning"
      icon="left"
      title={warning.title}
      description={
        <>
          {/* Rendered unconditionally, and toggled with `hidden`, so aria-controls always
              resolves to a real element instead of a dangling IDREF while collapsed. */}
          <p id={descriptionId} hidden={!expanded}>
            {warning.description}
          </p>
          <button
            type="button"
            className="fwa__toggle"
            onClick={() => setExpanded(current => !current)}
            aria-expanded={expanded}
            aria-controls={descriptionId}
          >
            {expanded ? 'Show less' : 'Learn more'}
          </button>
        </>
      }
    />
  );
};
